import { Toast } from 'antd-mobile';
import classnames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { isBrowser } from '@/common/const';
import {
  getCurrPlatformText,
  isJoJoBrowser,
  isJoJoReadBrowser,
  miniProgramNavigateTo,
  ownMiniApp
} from '@/utils';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';

import styles from './index.module.scss';

const cx = classnames.bind(styles);

type IProps = {
  sensData?: any;
  nickname?: string;
  phone: string;
  avatar?: string;
  userId?: string;
  isConfirmType?: boolean;
  confirmMessage?: string;
  disableClose: boolean;
  onClose: (val: boolean) => void;
};

class SignOut extends React.Component<IProps> {
  modalContainer: HTMLDivElement;

  constructor(props: IProps) {
    super(props);
    this.modalContainer = document.createElement('div');
    document.body.appendChild(this.modalContainer);
  }

  componentWillUnmount() {
    // 卸载模态对话框的 DOM 节点
    ReactDOM.unmountComponentAtNode(this.modalContainer);
    // 从 body 中移除模态对话框的容器
    document.body.removeChild(this.modalContainer);
  }

  showLogin() {
    if (isBrowser) {
      const minAppId = ownMiniApp();
      if (minAppId) {
        miniProgramNavigateTo({
          url: '/pages/transform_space/main?type=mine'
        });
      } else if (isJoJoReadBrowser()) {
        window.location.href = 'tinman-router://cn.tinman.jojoread/mine/settings';
      } else {
        Toast.loading('加载中...', 2);
        jojoAccount.popupLogin({
          wechatLogin: {
            mode: 1,
            wechatAuthType: 1
          },
          callback: () => {
            window.location.reload();
          }
        });
      }
    }
  }

  render() {
    const {
      sensData,
      phone,
      onClose,
      nickname,
      avatar,
      userId,
      isConfirmType = false,
      confirmMessage = '',
      disableClose = false
    } = this.props;

    return ReactDOM.createPortal(
      <div className={styles['cp-signout']}>
        {isConfirmType ? (
          <div className={cx('box', 'confirmBox')}>
            <p>{confirmMessage}</p>
            <div className={cx('confirm-btn-box')}>
              <button
                className={cx('cancel-btn')}
                onClick={() => {
                  onClose(false);
                }}
                type='button'>
                继续使用
              </button>
              <button
                onClick={async () => {
                  onClose(false);
                  this.showLogin();
                  const platform = await getCurrPlatformText();
                  sensClickInitiative({
                    $element_name: '运营活动活动页_拦截弹窗',
                    $element_content: '切换账号',
                    activity_id: sensData.activity_id,
                    material_ids: sensData.material_ids,
                    material_type: '用户不在老师班期',
                    custom_platform: platform
                  });
                }}
                type='button'>
                切换账号
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.box}>
            <h3>温馨提示</h3>
            <p>活动暂未对当前登录账户开放</p>
            <button
              onClick={() => {
                if (disableClose) {
                  return;
                }
                onClose(false);
              }}
              type='button'>
              我知道啦
            </button>
            <div className={cx('change-account-box')}>
              <div className={cx('title-box')}>
                <div className={cx('title')}>当前登录账号</div>
                <div
                  className={cx('title-right')}
                  onClick={async () => {
                    onClose(false);
                    this.showLogin();
                    const platform = await getCurrPlatformText();
                    sensClickInitiative({
                      $element_name: '运营活动活动页_拦截弹窗',
                      $element_content: '切换账号',
                      activity_id: sensData.activity_id,
                      material_ids: sensData.material_ids,
                      material_type: '无资格',
                      custom_platform: platform
                    });
                  }}>
                  <i className='ui-icon ui-icon__img56' />
                  <span className={cx('text-organge')}>切换账号</span>
                </div>
              </div>
              <div className={cx('account-info-box')}>
                <div className={cx('avatar')}>
                  <img src={avatar} alt='' />
                </div>
                <div className={cx('account-info')}>
                  <div className={cx('account-info-number')}>学号： {userId}</div>
                  <div className={cx('account-info-phone')}>已绑定： {phone || nickname}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>,
      this.modalContainer
    );
  }
}

const isJoJo = isJoJoBrowser();
const isJoJoRead = isJoJoReadBrowser();

const SignModal = ({
  phone,
  show,
  nickname,
  sensData,
  avatar,
  userId,
  isConfirmType,
  confirmMessage,
  disableClose = false
}: Pick<IProps, 'confirmMessage' | 'isConfirmType' | 'phone' | 'sensData' | 'avatar' | 'userId'> & {
  show: boolean;
  nickname?: string;
  disableClose?: boolean;
}) => {
  const [open, setOpen] = useState(show);

  useEffect(() => {
    if (!(isJoJo && !isJoJoRead) && show) {
      sensElementView({
        c_element_name: '运营活动活动页_拦截弹窗',
        material_type: '无资格',
        ...sensData
      });
    }
  }, []);

  useEffect(() => {
    if (!phone) {
      // sp91 双账号问题，登录用户无手机号，直接显示手机号登录弹窗
      jojoAccount.popupLogin({
        wechatLogin: {
          mode: 1,
          wechatAuthType: 1
        },
        showWechatBtn: false,
        callback: () => {
          window.location.reload();
        }
      });
    }
  }, [phone]);

  if (isJoJo && !isJoJoRead) {
    return null;
  }

  if (!phone) {
    return null;
  }

  return open ? (
    <SignOut
      userId={userId}
      avatar={avatar}
      sensData={sensData}
      phone={phone}
      disableClose={disableClose}
      nickname={nickname}
      isConfirmType={isConfirmType}
      confirmMessage={confirmMessage}
      onClose={(val) => {
        setOpen(val);
      }}
    />
  ) : null;
};

export default SignModal;
